import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-large-vertical-version",
  "use": "icon-large-vertical-version-usage",
  "viewBox": "0 0 56 94",
  "content": "<symbol viewBox=\"0 0 56 94\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-large-vertical-version\"><title>712</title><g fill=\"none\" fill-rule=\"evenodd\"><rect stroke=\"#DCDEE3\" fill=\"#FFF\" x=\".5\" y=\".5\" width=\"55\" height=\"93\" rx=\"4\" /><path d=\"M4 0h48a4 4 0 0 1 4 4v73H0V4a4 4 0 0 1 4-4z\" fill=\"#E88E00\" opacity=\".8\" /><path fill=\"#3B4457\" opacity=\".044\" d=\"M17 80h22v5H17zM6 87h44v3H6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol